import { render, staticRenderFns } from "./KanbanContainer.vue?vue&type=template&id=27f2efa6&"
import script from "./KanbanContainer.vue?vue&type=script&lang=js&"
export * from "./KanbanContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports